import { DialogRef } from '@angular/cdk/dialog';
import { Component, DestroyRef, inject, Input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { AlertService, NotificationService } from '@app/core';
import { CourseContent } from '@app/core/models/course-content';
import { SubdivionService } from '@app/core/services/subdivisions.service';
import { notNull } from '@app/shared/utils';
import { Strategy } from '@app/shared/modules/template/components/popover';
import { EMPTY } from '@app/shared/modules/user-photo/user-photo.component';
import { map, Observable } from 'rxjs';
import { StudioFilterService, TrailsService } from '../../services';

@Component({
  selector: 'app-tree-trail',
  templateUrl: './tree-trail.component.html',
  standalone: false,
})
export class TreeTrailComponent {
  private readonly trilhasService = inject(TrailsService);
  private readonly notificationService = inject(NotificationService);
  private readonly alertService = inject(AlertService);
  private readonly studioFilterService = inject(StudioFilterService);
  private readonly subdivionService = inject(SubdivionService);
  private readonly router = inject(Router);
  private readonly dialogRef = inject(DialogRef);
  private readonly destroyRef = inject(DestroyRef);
  public readonly empty = EMPTY;
  public readonly strategy = Strategy;
  @Input() public trail: CourseContent;
  @Input() public course_slug: string;
  @Input() public contents = [];
  @Input() public last: boolean = false;
  @Input() public first: boolean = false;

  public subdivisao: CourseContent;
  public popoverResult$: Observable<any>;

  public setOrder(reordenar: number): void {
    this.trilhasService.setOrder(this.trail.id, reordenar).subscribe(() => {
      this.notificationService.success('geral.sucesso');
      this.getSubdivisions();
    });
  }

  public onEditTrail(trail: any) {
    this.router.navigate([new URL(window.location.href).pathname, 'trilha', trail.slug]);
    this.dialogRef.close({ reset: true });
  }

  public getSubdivisions() {
    this.subdivionService
      .getSubdivision(this.trail.curso_id)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        notNull(),
        map((resp) => resp.data),
      )
      .subscribe({
        next: (data) => {
          this.studioFilterService.passItems(data);
        },
        error: (e) => this.alertService.alert({ message: e.error.msg }),
      });
  }
}
